module.exports = __webpack_public_path__ + "media/images/markers/fixed-2x-a56d652f15cbae97b706bf1e7619b88d.png";